namespace TabAurous.Sales {
    export namespace RFMAnalysisService {
        export const baseUrl = 'Sales/RFMAnalysis';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Sales/RFMAnalysis/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>RFMAnalysisService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
